export const REDUCER_NAME="subCategorieSlice";

// Interface for a single category
export interface iSubCategory {
    id: string;
    vendor_id: string;
    name: string;
    slug: string;
    category: string;
    display_type: string;
    description: string;
    image?: string | null;
    created_at: string;
    updated_at: string;
  }
  
  export interface iSubCategoryState {
    isLoading: boolean;
    subCategory: iSubCategory | null; // A single category object
    errorMessage: string | null;
    subCategoryList:iSubCategory[]
  }
  